import MarcoSidebarButtons from 'components/sidebar/MarcoSidebarButtons';
import React, { useState, useEffect } from 'react';

import { Col, Row } from 'react-bootstrap';
import './MarcoScore.scss';

import { useRMDispatch } from 'redux/hooks';
import { isNullOrUndefined, showAlertSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import MarcoService from 'business/services/MarcoService';
import {
  BooleanPropertyDTO,
  DisputedScoresIds,
  MarcoPlateInfoDto,
  MarcoScoreInfo,
} from 'business/models/Models';
import { RMModal, LoadingModal } from 'components/modal';
import RMCustomModal from 'components/customComponents/Controls/RMCustomModal';
import { RMCheckBoxY } from 'components/customComponents/Controls/RMCheckbox';
import RecomendedScoreRadioButtons from './DisputedScoreModal/RecomendedScoreRadioButtons/RecomendedScoreRadioButtons';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { IStyle } from 'Styles';
import { toggleScoringWell } from 'redux/reducers/experimentDataReducer';
import { DropDetails } from 'components/well/constants';
import { GlobalPreferencesService } from 'business/services/GlobalPreferencesService';
import SideBarComponent from '../SideBarComponent/SideBarComponent';
import AutoScores from '../AutoScore/AutoScores';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { useAllWellNavigationDetails } from 'redux/hooks/experiment';
import useRMLite from 'CustomHooks/useRMLite';
import { FmlxBanner } from 'fmlx-common-ui';
interface DisputeModalBodyProps {
  scoreGroups: Array<any>;
  disputedScoreGroupId: DisputedScoresIds[];
  setDisputedScoreGroupId: any;
  setSelectedScoreGroupsCountForDispute: any;
  setDisputeReason: any;
  setRecommendedScore: any;
  selectedScore: string;
}
function DisputeModalBody({
  scoreGroups,
  setSelectedScoreGroupsCountForDispute,
  disputedScoreGroupId,
  setDisputedScoreGroupId,
  setDisputeReason,
  setRecommendedScore,
  selectedScore,
}: DisputeModalBodyProps) {
  const recomendedScoresList = [
    { value: '0', text: 'Clear' },
    { value: '1', text: 'Bad Precipitate' },
    { value: '2', text: 'Good Precipitate' },
    { value: '3', text: 'Interesting' },
    { value: '4', text: 'Crystal' },
  ];

  function AddScoreToDisputed(imageBatchWellDropScoreID: number, dropToScoreID: number) {
    const disputedScores = disputedScoreGroupId;
    const index = disputedScores
      .map((item) => {
        return item.imageBatchWellDropScoreID;
      })
      .indexOf(imageBatchWellDropScoreID);
    if (index == -1) {
      const disputedScoreIds: DisputedScoresIds = new DisputedScoresIds();
      disputedScoreIds.imageBatchWellDropScoreID = imageBatchWellDropScoreID;
      disputedScoreIds.dropToScoreID = dropToScoreID;
      disputedScores.push(disputedScoreIds);
    } else {
      disputedScores.splice(index, 1);
    }
    setSelectedScoreGroupsCountForDispute(disputedScores.length);
    setDisputedScoreGroupId(disputedScores);
  }

  function recommendedScoreHandleOptionChange(optionValue) {
    setRecommendedScore(optionValue);
  }

  return (
    <div
      id="commandpanel-marcoscore-disputemodalbody-container"
      className="container"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <Row
        id="commandpanel-marcoscore-disputemodal-text-confirm"
        style={{ paddingBottom: '1.2vh' }}
      >
        <Col>
          <div
            id="commandpanel-marcoscore-disputemodal-text-confirm-message"
            className="modal-text"
          >
            Are you sure want to dispute MARCO Score of this drop?
          </div>
        </Col>
      </Row>

      <Row id="commandpanel-marcoscore-disputemodal-text-selectgroup">
        <Col>
          <div
            id="commandpanel-marcoscore-disputemodal-text-selectgroup-message"
            className="modal-text"
          >
            Please select which score group got it wrong.
          </div>
        </Col>
      </Row>
      {scoreGroups.map((item, i) => (
        <div
          id={`commandpanel-marcoscore-disputemodal-scoregroup-${item.imageBatchWellDropScoreID}`}
          key={`-score-group-${i}`}
          style={styles.disputeModalRow}
        >
          <RMCheckBoxY
            isChecked={disputedScoreGroupId
              .map((ids) => {
                return ids.imageBatchWellDropScoreID;
              })
              .includes(item.imageBatchWellDropScoreID)}
            onChange={() => {
              AddScoreToDisputed(item.imageBatchWellDropScoreID, item.dropToScoreID);
            }}
          />
          <div
            id={`commandpanel-marcoscore-disputemodal-scoregroup-text-${item.imageBatchWellDropScoreID}`}
            style={styles.scoreGroupTextContainer}
            className="d-flex flex-row"
          >
            <div
              id={`commandpanel-marcoscore-disputemodal-scoregroup-text-${item.scoreGroupName}`}
              style={styles.scoreGroupName}
            >
              {item.scoreGroupName + ': '}
            </div>
            <div
              id={`commandpanel-marcoscore-disputemodal-scorename-text-${item.scoreName}`}
              style={styles.scoreName}
            >
              {item.scoreName}
            </div>
          </div>
        </div>
      ))}

      <Row
        id="commandpanel-marcoscore-disputemodal-text-correctscore"
        style={{ paddingTop: '1.2vh' }}
      >
        <Col>
          <div
            id="commandpanel-marcoscore-disputemodal-text-correctscore-message"
            className="modal-text"
          >
            What is the correct score?
          </div>
        </Col>
      </Row>

      <Row
        id="commandpanel-marcoscore-disputemodal-correctscore-options"
        style={{
          display: 'flex',
          alignContent: 'center',
          alignItems: 'center',
          marginLeft: '3%',
        }}
      >
        {recomendedScoresList.map((item, i) => (
          <RecomendedScoreRadioButtons
            key={`recommended-score-${i}`}
            recommendedScoreValue={item.value}
            recommendedScoreText={item.text}
            selectedScore={selectedScore}
            radioButtonSize={'20'}
            onChange={recommendedScoreHandleOptionChange}
          ></RecomendedScoreRadioButtons>
        ))}
      </Row>

      <Row
        id="commandpanel-marcoscore-disputemodal-comments-label"
        style={{ paddingTop: '1.2vh' }}
      >
        <Col>
          <div
            id="commandpanel-marcoscore-disputemodal-comments-label-message"
            className="modal-text"
          >
            Comments
          </div>
        </Col>
      </Row>

      <textarea
        id="commandpanel-marcoscore-disputemodal-comments-input"
        onChange={(e) => {
          setDisputeReason(e.target.value);
        }}
        rows={4}
        className="dispute-reason-text-area"
        style={{ width: '100%', marginBottom: '1.5vh' }}
        name="disputeReason"
      ></textarea>
    </div>
  );
}

const defaultMarcoScoreInfo = [[]];

interface Props {
  wellDetails?: DropDetails;
  handleOnMarkDisputedScore: (disputedScoresIds: DisputedScoresIds[]) => void;
  imageBatchId?: number;
  dropNumber?: number;
}
function MarcoScore(props: Props) {
  const {
    wellDetails: wellDetailsProp,
    handleOnMarkDisputedScore,
    imageBatchId,
    dropNumber,
  } = props;
  enum EModalType {
    AlertDialog = 0,
    DisputeDialog = 1,
  }

  const [showLoading, setShowLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showMarcoTrainingAlert, setshowMarcoTrainingAlert] = useState(false);
  const [modalType, setModalType] = useState(0);
  const [scoresGroup, setScoresGroup] = useState([]);
  const [alertType, setAlertType] = useState(EAlertType.INFO);
  const [alertTitle, setAlertTitle] = useState('ROCK MAKER');
  const [alertMessage, setAlertMessage] = useState('');
  const [isMarcoScoringEnabled, setIsMarcoScoringEnabled] = useState(true);
  const [isAutoScoreAllowed, setIsAutoScoreAllowed] = useState(true);

  const _imageBatchId = wellDetailsProp ? wellDetailsProp?.imageBatchId : imageBatchId;
  const _dropNumber = wellDetailsProp ? wellDetailsProp?.dropNumber : dropNumber;

  const wellNavigationDetails = useAllWellNavigationDetails();
  const lastSelectedWell = wellNavigationDetails?.[wellNavigationDetails?.length - 1];
  const wellNum = wellDetailsProp ? wellDetailsProp.wellNum : lastSelectedWell?.wellNum;
  const plateId = wellDetailsProp ? wellDetailsProp.plateID : lastSelectedWell?.plateID;

  const [marcoScoreInfo, setMarcoScoreInfo] = useState([]);
  const [selectedScoreGroupsCountForDispute, setSelectedScoreGroupsCountForDispute] =
    useState(0);

  const [disputedScoreGroupId, setDisputedScoreGroupId] = useState<DisputedScoresIds[]>(
    [],
  );
  const dispatch = useRMDispatch();
  const rmLite = useRMLite();
  const [recommendedScore, setRecommendedScore] = useState('0');
  const [disputeReason, setDisputeReason] = useState('');

  function setDefaultMarcoScoreInfo() {
    setMarcoScoreInfo(defaultMarcoScoreInfo);
  }

  function hideMarcoModal() {
    setShowModal(false);
  }

  async function fetchMarcoScoreInfo(plateID, imageBatchId, wellNumber, dropNumber) {
    if (
      !isNullOrUndefined(imageBatchId) &&
      !isNullOrUndefined(dropNumber) &&
      !isNullOrUndefined(plateID) &&
      !isNullOrUndefined(wellNumber) &&
      isAutoScoreAllowed
    ) {
      // getMarcoScoreInfo
      const marcoService = new MarcoService();
      const marcoScoreInfo: MarcoScoreInfo[] = await marcoService.getMarcoScoreInfo(
        plateID,
        imageBatchId,
        wellNumber,
        dropNumber,
      );
      if (isNullOrUndefined(marcoScoreInfo) || marcoScoreInfo.length == 0) {
        setDefaultMarcoScoreInfo();
      } else {
        setMarcoScoreInfo(marcoScoreInfo);
      }
    } else {
      setDefaultMarcoScoreInfo();
    }
  }

  async function fetchIsAutoScoredAllowed(plateID?: number) {
    if (isNullOrUndefined(plateId)) {
      setIsAutoScoreAllowed(false);
    } else {
      const marcoService = new MarcoService();
      const marcoPlateInfo: MarcoPlateInfoDto = await marcoService.isAutoScoredAllowed(
        plateID,
      );

      setIsAutoScoreAllowed(marcoPlateInfo?.isValidType ?? true);
    }
  }

  async function getNonDisputedScores() {
    setShowModal(false);
    setShowLoading(true);

    const marcoService = new MarcoService();
    const nonDisputedScores = await marcoService.GetNonDisputedScores(
      plateId,
      _imageBatchId,
      wellNum,
      _dropNumber,
    );
    setShowLoading(false);
    if (isNullOrUndefined(nonDisputedScores) || nonDisputedScores.length == 0) {
      setModalType(EModalType.AlertDialog);
      setShowModal(true);
      setAlertType(EAlertType.INFO);
      setAlertTitle('Dispute Auto Score');
      setAlertMessage('Auto score is already marked disputed.');
    } else {
      setShowModal(false);
      setAlertTitle('Dispute Auto Score');
      setModalType(EModalType.DisputeDialog);
      setShowModal(true);
      setScoresGroup(nonDisputedScores);
    }
  }

  async function sendScoresDispute(
    disputedScoresIds,
    recommendedScore: number,
    disputeReason: string,
  ) {
    setShowModal(false);

    setShowLoading(true);

    const marcoService = new MarcoService();
    const sendScoresDisputeResponse = await marcoService.SendDisputedScore(
      disputedScoresIds,
      recommendedScore,
      disputeReason,
    );
    setShowLoading(false);
    if (!isNullOrUndefined(sendScoresDisputeResponse)) {
      if (sendScoresDisputeResponse == true) {
        handleOnMarkDisputedScore(disputedScoreGroupId);

        dispatch(toggleScoringWell());

        showAlertSnackBar(
          EAlertType.SUCCESS,
          ESnackBarPosition.TOP,
          'Dispute Score has been sent successfully',
        );
      } else {
        showAlertSnackBar(
          EAlertType.ERROR,
          ESnackBarPosition.TOP,
          'No score found for dispute',
        );
      }
    }
  }

  const getMarcoAutoScoreEnabledStatus = async () => {
    const globalPreferencesService = new GlobalPreferencesService();
    const property = (await globalPreferencesService.getProperty(
      'Scores.MARCOAutoScoring.Enabled',
    )) as BooleanPropertyDTO;
    setIsMarcoScoringEnabled(property.value);
  };

  useEffect(() => {
    getMarcoAutoScoreEnabledStatus();
  }, []);

  async function setMarcoTrainingAndImprovementStatus(
    collectRetrainingImages,
    autoCollectRetrainingImages,
  ) {
    setshowMarcoTrainingAlert(false);
    setShowLoading(true);

    const marcoService = new MarcoService();
    await marcoService.SetMarcoTrainingAndImprovementStatus(
      collectRetrainingImages,
      autoCollectRetrainingImages,
    );

    setShowLoading(false);
  }
  useEffect(() => {
    if (showModal == true && modalType == EModalType.DisputeDialog) {
      setDisputedScoreGroupId([]);
      setSelectedScoreGroupsCountForDispute(0);
      setRecommendedScore('0');
      setDisputeReason('');
    }
  }, [showModal]);
  useEffect(() => {
    fetchMarcoScoreInfo(plateId, _imageBatchId, wellNum, _dropNumber);
  }, [plateId, _imageBatchId, wellNum, _dropNumber]);

  useEffect(() => {
    // Autoscore will not work on LCP and Microfluidic plate
    fetchIsAutoScoredAllowed(plateId);
  }, [plateId]);

  async function sendToMarco(overwriteFlag = false) {
    setShowModal(false);
    setShowLoading(true);

    const marcoService = new MarcoService();
    const sendToMarcoResponse = await marcoService.SendToMarco(
      plateId,
      _imageBatchId,
      _dropNumber,
      overwriteFlag,
    );
    setShowLoading(false);
    if (!isNullOrUndefined(sendToMarcoResponse)) {
      setModalType(EModalType.AlertDialog);
      setShowModal(true);
      setAlertType(sendToMarcoResponse.alertType);
      setAlertTitle(sendToMarcoResponse.alertTitle);
      setAlertMessage(sendToMarcoResponse.alertMessage);
    }
  }

  const marcoToolsButtons = [
    {
      Icon: (
        <RMSvgIcon
          id="marcoscore-toolbuttons-disputescore-icon"
          name="DisputeScore"
          width={24}
          height={24}
        />
      ),
      title: 'Dispute Score',
      type: '',
      showActive: false,
      message: 'Did you disagree on our result? Send the selected images to let us know',
      onClick: async () => {
        await getNonDisputedScores();
      },
      isDisabled:
        rmLite ||
        isNullOrUndefined(plateId) ||
        isNullOrUndefined(_imageBatchId) ||
        isNullOrUndefined(wellNum),
    },
    {
      Icon: (
        <RMSvgIcon
          id="marcoscore-toolbuttons-sendinspection-icon"
          name="SendInspection"
          width={24}
          height={24}
        />
      ),
      title: 'Auto Scoring',
      type: '',
      showActive: false,
      message: 'Send this inspection to your local server for Autoscoring.',
      onClick: async () => {
        await sendToMarco();
      },

      isDisabled:
        isNullOrUndefined(plateId) ||
        isNullOrUndefined(_imageBatchId) ||
        isNullOrUndefined(_dropNumber) ||
        !isMarcoScoringEnabled,
    },
  ];

  return (
    <div
      id="commandpanel-exppanel-marcoscore-wrapper"
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      <LoadingModal showModal={showLoading} text={'Please Wait'} />
      {isAutoScoreAllowed && (
        <>
          <RMCustomModal
            showModal={showMarcoTrainingAlert}
            setShowModal={setshowMarcoTrainingAlert}
            heading={alertTitle}
            buttonsList={[
              {
                id: 'commandpanel-exppanel-marcoscore-trainingalert-btn-yes',
                onClick: () => {
                  setMarcoTrainingAndImprovementStatus(true, true);
                },
                buttonText: 'Yes',
              },

              {
                id: 'commandpanel-exppanel-marcoscore-trainingalert-btn-no',
                onClick: () => {
                  setMarcoTrainingAndImprovementStatus(true, false);
                },
                buttonText: 'No',
              },

              {
                id: 'commandpanel-exppanel-marcoscore-trainingalert-btn-cancel',
                onClick: () => {
                  setshowMarcoTrainingAlert(false);
                },
                buttonText: 'Cancel',
              },
            ]}
            body={
              modalType == EModalType.AlertDialog ? (
                <p
                  id="commandpanel-exppanel-marcoscore-trainingalert-message"
                  style={{ whiteSpace: 'break-spaces' }}
                >
                  {alertMessage}
                </p>
              ) : (
                <DisputeModalBody
                  scoreGroups={scoresGroup}
                  setSelectedScoreGroupsCountForDispute={
                    setSelectedScoreGroupsCountForDispute
                  }
                  setRecommendedScore={setRecommendedScore}
                  setDisputeReason={setDisputeReason}
                  selectedScore={recommendedScore}
                  disputedScoreGroupId={disputedScoreGroupId}
                  setDisputedScoreGroupId={setDisputedScoreGroupId}
                ></DisputeModalBody>
              )
            }
          ></RMCustomModal>
          <RMModal
            id="commandpanel-exppanel-marcoscore-warningmodal"
            showModal={showModal}
            setShowModal={setShowModal}
            heading={alertTitle}
            isOkOnly={
              modalType == EModalType.DisputeDialog || alertType == EAlertType.WARNING
                ? false
                : true
            }
            okayDisabled={
              modalType == EModalType.DisputeDialog &&
              selectedScoreGroupsCountForDispute == 0
            }
            okButtonText="Ok"
            noButtonText="Cancel"
            onOk={
              modalType == EModalType.DisputeDialog
                ? async () => {
                    sendScoresDispute(
                      disputedScoreGroupId,
                      parseInt(recommendedScore),
                      disputeReason,
                    );
                  }
                : alertType == EAlertType.WARNING
                ? async () => {
                    await sendToMarco(true);
                  }
                : modalType == EModalType.AlertDialog
                ? hideMarcoModal
                : () => {
                    setShowModal(false);
                  }
            }
            body={
              modalType == EModalType.AlertDialog ? (
                <p
                  id="commandpanel-exppanel-marcoscore-warningmodal-message"
                  style={{ whiteSpace: 'break-spaces' }}
                >
                  {alertMessage}
                </p>
              ) : (
                <DisputeModalBody
                  scoreGroups={scoresGroup}
                  setSelectedScoreGroupsCountForDispute={
                    setSelectedScoreGroupsCountForDispute
                  }
                  setRecommendedScore={setRecommendedScore}
                  setDisputeReason={setDisputeReason}
                  selectedScore={recommendedScore}
                  disputedScoreGroupId={disputedScoreGroupId}
                  setDisputedScoreGroupId={setDisputedScoreGroupId}
                ></DisputeModalBody>
              )
            }
          ></RMModal>

          <div
            id="commandpanel-exppanel-marcoscore-scoreslist"
            className="h-[52vh] overflow-y-auto"
          >
            {marcoScoreInfo.map((scoreInfo, index) => (
              <SideBarComponent
                key={`marco-score-key-${index}`}
                heading={scoreInfo.model ? `${scoreInfo.model}` : 'Well not scored'} // Pass the model to heading
                subHeading={
                  scoreInfo.fasaScore
                    ? `Composite Score: ${(scoreInfo.fasaScore * 100).toFixed(2)}%`
                    : ''
                }
                subHeadingStyle={{
                  marginLeft: 'auto',
                  textAlign: 'right',
                  paddingRight: '2%',
                }}
                isCollapsible={scoreInfo.model ? true : false}
                handleColapse={() => {}}
                isCollapsedFirstTime={true}
                ContainerComponent={
                  <AutoScores
                    scoreDetails={scoreInfo.scoreDetails}
                    morphologyDetails={scoreInfo.morphologyDetails}
                    ultravioletDetails={scoreInfo.ultravioletDetails}
                  />
                }
              />
            ))}
          </div>

          <div id="commandpanel-exppanel-marcoscore-buttonsrow" className="row">
            <div className="col-md-12">
              <MarcoSidebarButtons
                id="commandpanel-exppanel-marcoscore-buttons"
                height={'100%'}
                width={'100%'}
                buttons={marcoToolsButtons}
              />
            </div>
          </div>
          <div
            id="commandpanel-exppanel-marcoscore-footer"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          ></div>
        </>
      )}

      {!isAutoScoreAllowed && (
        <FmlxBanner
          id="commandpanel-exppanel-marcoscore-autoscore-unavailable"
          title={`Currently the Autoscore isn't available for LCP and Microfluids plate type.`}
          hideCloseButton={true}
        />
      )}
    </div>
  );
}

const styles: IStyle = {
  disputeModalRow: {
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    marginLeft: '1%',
  },
  scoreGroupTextContainer: {
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    wordBreak: 'break-word',
    textOverflow: 'ellipsis',
  },
  scoreGroupName: {
    marginLeft: 3,
    fontWeight: 'normal',
    display: 'flex',
    alignItems: 'center',
  },
  scoreName: {
    fontStyle: 'italic',
    fontWeight: 'normal',
    display: 'flex',
    alignItems: 'center',
  },
};
export default React.memo(MarcoScore);
